// extracted by mini-css-extract-plugin
module.exports = {"content":"body_content___1oKU"};